import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CaseBackendServer extends BaseBackend {

  getCases(builder): Observable<any> {
    return this.get('/case', { params: builder });
  }

  exportCases(builder): Observable<any> {
    return this.post('/case/export', builder);
  }

  getCase(caseNo): Observable<any> {
    return this.get(`/case/${ caseNo }`);
  }

  saveCase(data): Observable<any> {
    const { caseNo } = data;
    if (caseNo) {
      return this.patch(`/case/${ caseNo }`, data);
    }
    return this.post('/case', data);
  }

  deleteCase(data): Observable<any> {
    const { caseNo } = data;
    return this.delete(`/case/${ caseNo }`, data);
  }

  updateCaseRejectTicket(data): Observable<any> {
    const { ticketNo, caseNo } = data;
    return this.patch(`/case/${ caseNo }/reject-ticket-status/${ ticketNo }`, data);
  }

  saveCaseProduct(data): Observable<any> {
    const { ticketNo, caseNo } = data;
    if (ticketNo) {
      return this.patch(`/case/${ caseNo }/case-ticket/${ ticketNo }`, data);
    }
    return this.post(`/case/${ caseNo }/case-ticket`, data);
  }

  deleteCaseProduct(data): Observable<any> {
    const { ticketId, caseNo } = data;
    return this.delete(`/case/${ caseNo }/case-ticket/${ ticketId }`, data);
  }

  getCheckSerial(serialNo): Observable<any> {
    return this.get(`/case/check-serial/${ serialNo }`);
  }

  getB2bSymptoms(productType): Observable<any> {
    return this.get(`/case/b2b-symptoms/${ productType }`);
  }

  serverFileUpload(formData): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const options = {
      headers,
      reportProgress: true,
    };

    const uploadReq = new HttpRequest('POST', `${ this.backend }/case/file/temp-file`, formData, options);

    return this.http.request(uploadReq).pipe(timeout(500000));
  }

  deleteFile(params: any): Observable<any> {
    const { ticketNo } = params;
    return this.delete(`/case/file/${ ticketNo }`, { params });
  }

  workflowStatusUpdate(data): Observable<any> {
    const { caseNo, workFlowStatus } = data;
    return this.patch(`/case/${ caseNo }/${ workFlowStatus }`, data);
  }

  caseProductApprove(data): Observable<any> {
    const { caseNo } = data;
    return this.post(`/case/${ caseNo }/approve`, data);
  }

  updateTicketStatus(data): Observable<any> {
    const { caseNo } = data;
    return this.get(`/case/${ caseNo }/sync`, data);
  }

  updateTicketAscNo(data): Observable<any> {
    const { caseNo } = data;
    return this.patch(`/case/${ caseNo }/asc-no`, data);
  }

  updateExchangeReason(data): Observable<any> {
    const { caseNo } = data;
    return this.patch(`/case/${ caseNo }/exchange-reason`, data);
  }

  updateTrackingStatus(data): Observable<any> {
    const { caseNo } = data;
    return this.patch(`/case/${ caseNo }/update-tracking-status`, data);
  }

  changePartnerOrganization(data): Observable<any> {
    const { caseNo } = data;
    return this.patch(`/case/${ caseNo }/partner-organization`, data);
  }
}
